import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

import { APP_CONFIG } from '../../../core/config/app-config.token';

import { TranslationStore } from './translation.store';

export function provideI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() =>
      inject(TranslationStore).use(inject(APP_CONFIG).i18n.defaultLanguage),
    ),
  ]);
}
